import { useContext, useState } from 'react'

import { useHealthToolsCache } from '@hhgtech/hhg-components'
// import { LOCALE } from '@hhgtech/hhg-components/types'
import dayjs from 'dayjs'
import { useIntl } from 'react-intl'

import { getHelloSitesUrl } from 'api/utils/paths'
import { redirectToSSOWithReturnUrl } from 'api/utils/redirects'
import { AdBlock } from 'components/molecules/adBlock'
import { BmiFormHelpers } from 'components/molecules/bmiForm'
import { OvulationCalculatorCard } from 'components/organisms/ovulationCalculatorCard'
import { OvulationCalculator } from 'components/templates/ovulationCalculator'
import { OvulationInfo } from 'components/templates/ovulationCalculator/ovulationInfo'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { basePath } from 'interfaces/constants'
import { HEALTH_TOOL_TYPE } from 'interfaces/constants/healthTools'
import { AppContext } from 'state/appContext'

import { OvulationPageComponent } from '.'
import { useOvulationFormContext } from './context'
import { getOvulationResultLink, useDrawCalendar } from './helpers'

type OvulationContentProps = {
  ovulationPageInfo: React.ComponentProps<
    typeof OvulationPageComponent
  >['ovulationPageInfo']
  adUnitPath?: string
  enabledAd?: boolean
}
export const OvulationContent = ({
  enabledAd,
  ovulationPageInfo,
  adUnitPath,
}: OvulationContentProps) => {
  const { formatMessage: f } = useIntl()
  const { locale, router } = useRouterExtend()
  const { getHealthToolLink } = useHealthToolsCache(locale)

  const form = useOvulationFormContext()

  const [selectedDate, setSelectedDate] = useState<Date>(new Date())
  const [startDate, setStartDate] = useState(() => {
    const d = new Date()
    if (d.getDay() === 0) {
      return dayjs(d).subtract(1, 'day').toDate()
    }
    return d
  })

  const { ovulationMarkers, calendarRanges, ovulationDays } = useDrawCalendar(
    form.values,
  )

  const {
    state: { userInfo },
  } = useContext(AppContext)

  const handleSubmit = () => {
    if (
      // form.values.isSubmitted &&
      typeof userInfo !== 'undefined' &&
      getHealthToolLink(HEALTH_TOOL_TYPE.OVULATION)
    ) {
      if (!userInfo?.id) {
        BmiFormHelpers.syncParamsToUseOnSSOForm(
          {
            gender: form.values.isYourself ? 'female' : '',
            birthday: form.values.isYourself ? form.values.birthday : undefined,
          },
          router,
        )
        redirectToSSOWithReturnUrl(
          getOvulationResultLink(
            `${getHelloSitesUrl(locale)}${basePath}${getHealthToolLink(
              HEALTH_TOOL_TYPE.OVULATION,
            )}`,
            form.values,
          ),
          'ovulation',
        )
      } else {
        form.setFieldValue('isSubmitted', true)
        window.scrollTo(0, 0)
        router.push(
          getOvulationResultLink(
            getHealthToolLink(HEALTH_TOOL_TYPE.OVULATION),
            form.values,
          ),
          undefined,
          { shallow: true },
        )
      }
    }
  }

  return (
    <>
      {!form.values || !form.values.isSubmitted ? (
        <>
          <OvulationCalculator
            additionalQuestions={ovulationPageInfo.listQuestions}
            onCalc={handleSubmit}
          />
          {adUnitPath && enabledAd && (
            <AdBlock
              adUnitPath={adUnitPath}
              className="top-ad"
              size={[
                [300, 250],
                [300, 600],
              ]}
              divId={'div-gpt-ad-topbanner-mobile'}
              pos={['TopBanner']}
            />
          )}
          {ovulationPageInfo?.info && (
            <OvulationInfo
              heading={f({ id: 'ovulationPage.faqs' })}
              infos={ovulationPageInfo.info || []}
            />
          )}
        </>
      ) : (
        <>
          <OvulationCalculatorCard
            startDate={startDate}
            selectedDate={selectedDate}
            onChangeStartDate={setStartDate}
            onChangeSelectedDate={setSelectedDate}
            calendarRanges={calendarRanges}
            calcObjective={form.values.type}
            ovulationDays={ovulationDays}
            ovulationMarkers={ovulationMarkers}
            onClickRecalculate={() => {
              router.push(getHealthToolLink(HEALTH_TOOL_TYPE.OVULATION))
            }}
          />
          {/* show with mobile */}
          {adUnitPath && enabledAd && (
            <AdBlock
              adUnitPath={adUnitPath}
              className="top-ad"
              size={[
                [300, 250],
                [300, 600],
              ]}
              divId={'div-gpt-ad-topbanner-mobile'}
              pos={['TopBanner']}
            />
          )}
        </>
      )}
    </>
  )
}
